// extracted by mini-css-extract-plugin
export default {"nameButton":"Bx2QUu"};